export default "__VITE_ASSET__By9sGFTf__"